import { ILogicModifier, IPairingLogicModifier } from "@vmosolutions/oc-interfaces";
import { isEqual } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { SelectField } from "src/components/FormikComponents/SelectField";
import { getBusinessLogicModifiers } from "src/redux/actions/CrewSchedule/CrewSchedule.Actions";

interface IDefinitionLogicModifiersProps {
  initialValue: IPairingLogicModifier[];
  value: IPairingLogicModifier[];
  onChange: (value: IPairingLogicModifier[]) => void;
  disabled?: boolean;
}

interface LMOption {
  value: IPairingLogicModifier;
  label: string;
}

const convertValueToOption = (plms: IPairingLogicModifier[]): LMOption[] => {
  return plms.map((plm) => {
    const valOption = { value: plm, label: plm.logicModifier.description };
    return valOption;
  });
};

export const DefinitionLMSelector = (props: IDefinitionLogicModifiersProps): JSX.Element => {
  const { initialValue, value, onChange, disabled } = props;
  const isDirty = !isEqual(initialValue, value);

  // Gets the applicable LMs
  const [options, setOptions] = useState<ILogicModifier[]>([]);

  useEffect(() => {
    let isCancelled = false;
    const getLogicModifiersAction = async (): Promise<void> => {
      const lms = await getBusinessLogicModifiers();
      if (!isCancelled) {
        setOptions(lms);
      }
    };
    getLogicModifiersAction();
    return () => {
      isCancelled = true;
    };
  }, []);

  const logicModifierOptions: LMOption[] = useMemo(() => {
    const lmOptions = convertValueToOption(
      options
        .filter((opt) => opt.allowableOnPairing !== false && opt.isActive)
        .map((lm) => {
          const pairingLM: IPairingLogicModifier = { dutyTime: null, logicModifier: lm };
          return pairingLM;
        })
    );
    return lmOptions.sort((a, b) => {
      return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
    });
  }, [options]);

  return (
    <SelectField
      name="definition_logicmodifiers"
      className={`logicmodifiers_control ${isDirty ? "dirty" : ""}`}
      label="Logic Modifiers"
      isMulti={true}
      onChange={(lms: LMOption[]) => {
        onChange(lms.map((lm) => lm.value));
      }}
      value={convertValueToOption(value)}
      options={logicModifierOptions}
      multiMode="checkbox"
      menuPlacement="auto"
      placeholder={`[${value
        .map((plm, i) => {
          return i > 0 ? " " + plm.logicModifier.title : plm.logicModifier.title;
        })
        .toString()}]`}
      meta={{
        initialValue: initialValue,
        touched: isDirty,
      }}
      disabled={disabled}
    />
  );
};
